<template>
  <div class="billing-history-table">
    <div class="contract-period-label">
      <div class="contract-period-label-start-gap">
        <span class="contract-period-label-text">利用開始月</span><span>{{ options.startMonth }}</span>
      </div>
      <div class="contract-period-label-end-gap">
        <span class="contract-period-label-text">利用終了月</span>
        <el-tooltip placement="top">
          <div slot="content">
            利用終了月の翌月から、ATELUにアクセスできなくなります。<br />
            抽選、当選連絡、データのダウンロードは期間内に完了してください。
          </div>
          <i class="mdi mdi-help-circle"></i> </el-tooltip
        ><span>{{ options.endMonth }}</span>
      </div>
    </div>
    <el-table class="mb-x2" :data="billingHistories" stripe @header-click="headerClick">
      <el-table-column label="請求月" sort-by="-target_month" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">{{ formatYearMonth(scope.row.targetMonth) }}</template>
      </el-table-column>
      <el-table-column label="ユーザー数" sort-by="-result_user_count" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope"
          >{{ formatNumber(scope.row.resultUserCount) }}
          <div v-if="scope.row.maxUserCount !== 0">(上限: {{ formatNumber(scope.row.maxUserCount) }})</div>
        </template>
      </el-table-column>
      <el-table-column
        label="アカウント数"
        sort-by="-result_account_count"
        :render-header="renderHeader"
        min-width="15%"
      >
        <template slot-scope="scope"
          >{{ formatNumber(scope.row.resultAccountCount) }}
          <div v-if="scope.row.maxAccountCount !== 0">(上限: {{ formatNumber(scope.row.maxAccountCount) }})</div>
        </template>
      </el-table-column>
      <el-table-column
        label="キャンペーン同時開催数"
        sort-by="-result_campaign_count"
        :render-header="renderHeader"
        min-width="20%"
      >
        <template slot-scope="scope"
          >{{ formatNumber(scope.row.resultCampaignCount) }}
          <div v-if="scope.row.maxCampaignCount !== 0">(上限: {{ formatNumber(scope.row.maxCampaignCount) }})</div>
        </template>
      </el-table-column>
      <el-table-column
        label="収集応募者数"
        sort-by="-result_monthly_applicant_count"
        :render-header="renderHeader"
        min-width="15%"
      >
        <template slot-scope="scope"
          >{{ formatNumber(scope.row.resultMonthlyApplicantCount) }}
          <div v-if="scope.row.maxMonthlyApplicantCount !== 0">
            (上限: {{ formatNumber(scope.row.maxMonthlyApplicantCount) }})
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="DM配信数"
        sort-by="-result_monthly_dm_count"
        :render-header="renderHeader"
        min-width="15%"
      >
        <template slot-scope="scope"
          >{{ formatNumber(scope.row.resultMonthlyDmCount) }}
          <div v-if="scope.row.maxMonthlyDmCount !== 0">(上限: {{ formatNumber(scope.row.maxMonthlyDmCount) }})</div>
        </template>
      </el-table-column>
    </el-table>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        type="利用実績"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import { formatNumber, formatYearMonth } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'

export default defineComponent({
  components: {
    Pagination
  },
  props: {
    billingHistories: Array,
    options: Object,
    onChangeSortBy: Function,
    onChangePagingNo: Function,
    onChangeLimitCount: Function
  },
  methods: {
    formatNumber,
    formatYearMonth,

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case '請求月':
          TrackingService.sendEvent('sort:グループ設定|利用実績|請求月')
          break
        case 'ユーザー数':
          TrackingService.sendEvent('sort:グループ設定|利用実績|ユーザー数')
          break
        case 'アカウント数':
          TrackingService.sendEvent('sort:グループ設定|利用実績|アカウント数')
          break
        case 'キャンペーン同時開催数':
          TrackingService.sendEvent('sort:グループ設定|利用実績|キャンペーン同時開催数')
          break
        case '収集応募者数':
          TrackingService.sendEvent('sort:グループ設定|利用実績|収集応募者数')
          break
        case 'DM配信数':
          TrackingService.sendEvent('sort:グループ設定|利用実績|DM配信数')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.contract-period-label {
  display: flex;
  gap: $spacing-unit * 6;
  align-items: center;
  margin-top: $spacing-unit;
  margin-bottom: $spacing-unit;
}

.contract-period-label-start-gap {
  display: flex;
  gap: $spacing-unit * 2;
  align-items: center;
}

.contract-period-label-end-gap {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
}

.contract-period-label-text {
  font-size: $font-size;
  font-weight: bold;
  color: $sub-text-color;
}

.mdi-help-circle {
  font-size: $round * 5;
  color: $sub-text-color;
}
</style>
